export default __webpack_public_path__ + "static/summer_containers21-d6f01ac7520aa43e0bd9b89543d9339b.webp";